import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { playerConfig } from '@shared/player'
import { EpisodePlayback, IPlaybackProps } from '../episodePlayback/episodePlayback'
import { getFirstPlaybackData } from '../../utils/playbackActionHelper'
import * as st from './schedule.module.scss'
import { widgetNameClasses } from '../../utils/widgetNameClasses'
import { CollectionType } from '../collection/collectionTypes'
import { IDetailPageState } from '../../reducers'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { BTF_DECORATION_SCHEME } from '../../reducers/action'
import { isUpcoming, isDisrupted } from '../../utils/liveState'
import { DETAIL_FRAGMENT } from '../../reducers/detail'
import { playerConfigDataSelector } from '../../selectors/player'
import { isDeeplinkableActionReadySelector } from '../../selectors/pageContext'

interface OwnProps {
  idx: number
  collectionType: CollectionType
  titleId: string
}

type StateType = ReturnType<typeof mapStateToProps>
type Props = StateType & OwnProps

const isPlaybackAvailable = (ep?: WpsRuntime.atv.wps.ActionFragmentModelProps) =>
  Boolean(ep && getFirstPlaybackData(ep.playbackActions))

type BuildPlayback = {
  idx: number
  detail: WpsRuntime.atv.wps.DetailFragmentModelProps
  action?: WpsRuntime.atv.wps.ActionFragmentModelProps
  titleId: string
  playerConfigData: playerConfig.PlayerConfigData
  isDeeplinkableActionReady: boolean
}
const PlaybackWrapper = ({
  idx,
  detail,
  action,
  titleId,
  playerConfigData,
  isDeeplinkableActionReady,
}: BuildPlayback) => {
  if (!isPlaybackAvailable(action)) {
    return <>{detail.title}</>
  }

  const playbackProps = {
    title: detail.title,
    playbackActions: action && action.playbackActions,
    entityType: detail.entityType,
    playerConfigData,
    titleId,
    purchaseDetails: null,
    isRefunding: false,
    isDeeplinkableActionReady,
  } as IPlaybackProps
  return (
    <div className={`js-sch-ep-playback-wrapper`}>
      <div
        data-automation-id={`sch-ep-title-${idx}`}
        className={`${widgetNameClasses.playback} js-schedule-episode schedule-playback-wrapper`}
      >
        <EpisodePlayback {...playbackProps} />
      </div>
    </div>
  )
}

type StartTime = {
  startTime: string,
  liveState?: WpsRuntime.atv.wps.LiveStateProps
}
const StartTime = ({
  startTime,
  liveState}: StartTime
) => {
  if (!liveState) {
    return null
  } else if (isUpcoming(liveState.id)) {
    return <>{startTime}</>
  } else if (liveState.isLive) {
    return <div> <Badge use={badges.LIVE}> {liveState.text} </Badge> </div>
  } else if (isDisrupted(liveState.id)) {
    return <div> <Badge use={badges.CRITICAL}> {liveState.text} </Badge> </div>
  } else {
    return <div> <Badge use={badges.TEXT}> {liveState.text} </Badge> </div>
  }
}


const ConnectedScheduleItem = ({
  requestContext: { sessionID },
  playerConfigData,
  collectionType,
  idx,
  action,
  detail,
  titleId,
  isDeeplinkableActionReady,
}: Props) => {
  const { liveState, startDate = '', startTime = '' } = detail
  const playbackProps = {
    sessionID,
    idx,
    detail,
    playerConfigData,
    action,
    titleId,
    isDeeplinkableActionReady,
  }
  return (
    <li id={`av-ep-${collectionType}${idx}`} className={st.avScheduleItem}>
      <div className={st.avScheduleItemCol}>
        <PlaybackWrapper {...playbackProps} />
      </div>

      <div className={`${st.avScheduleItemCol} ${st.scheduleDateBadge}`}>
        {startDate}
      </div>
      <div className={`${st.avScheduleItemCol} ${st.scheduleTimeBadge}`}>
        <StartTime startTime={startTime} liveState={liveState} />
      </div>
    </li>
  )
}

const mapStateToProps = (
  state: IDetailPageState,
  ownProps: OwnProps
) => ({
  action: state.action[BTF_DECORATION_SCHEME][ownProps.titleId],
  playerConfigData: playerConfigDataSelector(state),
  detail: state.detail[DETAIL_FRAGMENT][ownProps.titleId]!,
  requestContext: sanitizedRequestContextSelector(state),
  isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
})

export const ScheduleItem = connect(mapStateToProps)(ConnectedScheduleItem)
